export default __webpack_public_path__ + "static/media/portrait_mobile-min.5b28c824.jpg";